import { render } from "./WorkflowShareDialog.vue?vue&type=template&id=2a399c68&scoped=true"
import script from "./WorkflowShareDialog.vue?vue&type=script&lang=js"
export * from "./WorkflowShareDialog.vue?vue&type=script&lang=js"

import "./WorkflowShareDialog.vue?vue&type=style&index=0&id=2a399c68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a399c68"]])

export default __exports__